




























































import { Component, BaseComponent } from '@/component';
import { projectToZip } from '@/services/zip';
import { Commit } from '@/store/actions';

@Component({})
export default class Export extends BaseComponent {
	async exportWidget() {
		const zip = await projectToZip(this.$store.state.project);

		const a = document.createElement('a');
		document.body.appendChild(a);
		a.download = `${this.$store.state.project.meta.name}.zip`;
		a.href = URL.createObjectURL(zip);
		a.click();

		a.remove();
	}

	get name(): string {
		return this.$store.state.project.meta.name;
	}

	set name(value: string) {
		this.$store.commit<Commit>({
			type: 'updateProject',
			project: {
				meta: {
					...this.$store.state.project.meta,
					name: value
				}
			}
		});
	}

	get version(): string {
		return this.$store.state.project.meta.version;
	}

	set version(value: string) {
		this.$store.commit<Commit>({
			type: 'updateProject',
			project: {
				meta: {
					...this.$store.state.project.meta,
					version: value
				}
			}
		});
	}

	get author(): string {
		return this.$store.state.project.meta.author;
	}

	set author(value: string) {
		this.$store.commit<Commit>({
			type: 'updateProject',
			project: {
				meta: {
					...this.$store.state.project.meta,
					author: value
				}
			}
		});
	}

	get description(): string {
		return this.$store.state.project.meta.description;
	}

	set description(value: string) {
		this.$store.commit<Commit>({
			type: 'updateProject',
			project: {
				meta: {
					...this.$store.state.project.meta,
					description: value
				}
			}
		});
	}
}
